export default __webpack_public_path__ + "static/media/blog-post.3.d5e7d3f9.md";